import { ObjectValueUserTeam } from './user.entity';

export class UserTeam {
    static create(userData: ObjectValueUserTeam): UserTeam {
        const { 
            team_id: teamId, 
            timestamp: timestampString,
            name,
            portal,
            chat,
            timeEntryAdmin,
            profile
        } = userData;
        const timestamp = new Date(timestampString);
        return new UserTeam (teamId, timestamp, portal, chat, timeEntryAdmin, name, profile);
    }

    static createArray(userDataArray: ObjectValueUserTeam[]) : UserTeam[] {
        const userTeams:UserTeam[] = [];

        for(const userTeam of userDataArray) {
            userTeams.push(this.create(userTeam));
        }

        return userTeams;
    }

    static createFromSerializedData(serializedData: string): UserTeam | undefined {
        try {
            const data = JSON.parse(serializedData);
            const {
                name,
                portal,
                chat,
                timeEntryAdmin,
                teamId,
                timestamp: serializedTimeStamp,
                profile
            } = data;
            
            const timestamp = new Date(serializedTimeStamp);
            return new UserTeam (teamId, timestamp, portal, chat, timeEntryAdmin, name, profile);
        } catch(e) {
            return;
        }
    }

    constructor (
        public readonly teamId: string,
        public readonly timestamp: Date,
        public readonly portal: boolean,
        public readonly chat: boolean,
        public readonly timeEntryAdmin: boolean,
        public readonly name?: string,
        public readonly profile?: string[]
    ) {}

    public serialize(): string {
        const {
            name,
            portal,
            chat,
            timeEntryAdmin,
            teamId,
            timestamp,
            profile
        } = this;

        const objectToSerialize = {
            portal,
            chat,
            timeEntryAdmin,
            teamId,
            timestamp: timestamp.getTime(),
            profile
        };
        if (name) {
            Object.assign(objectToSerialize, {name});
        }

        return JSON.stringify(objectToSerialize);
    }
}
